import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api/index.ts";
import { loadStytch } from "@/lib/stytch.ts";

export const useGetSuggestedReplies = (
  mentorshipId: string,
  lastMessageId: string,
) => {
  return useQuery({
    queryKey: ["suggestedReplies", mentorshipId, lastMessageId],
    queryFn: async () => {
      const { data } = await fetchApi({
        url: `v2/messages/${mentorshipId}/suggested-replies`,
        method: "GET",
      });

      return data;
    },
    enabled: !!mentorshipId && !!lastMessageId,
  });
};

interface ChatHistory {
  chatHistory: {
    message: string;
    type: "user" | "assistant";
  }[];
}

export const useGetMentorshipAIChatHistory = (
  mentorshipId: string,
  enabled = true,
) => {
  return useQuery({
    queryKey: ["mentorshipAIChatHistory", mentorshipId],
    queryFn: async () => {
      const { data } = await fetchApi<ChatHistory>({
        url: `v2/messages/${mentorshipId}/chat`,
        method: "GET",
      });

      return data?.chatHistory || [];
    },
    enabled: enabled && !!mentorshipId,
  });
};

export const generateAIResponseForMentorship = async (
  mentorshipId: string,
  message: string,
  signal?: AbortSignal,
) => {
  const client = loadStytch();
  const tokens = client.session.getTokens();

  return fetch(
    `${import.meta.env.VITE_API_URL}/v2/messages/${mentorshipId}/chat`,
    {
      method: "POST",
      body: JSON.stringify({ message }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokens?.session_jwt}`,
      },
      signal,
    },
  );
};
